import React,{useState} from 'react';
import { BASE_URL } from '../../utils/config';
import ReactSelect from 'react-select'
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Loading from '../loading';
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
const OptionSection = ({ stockSymbols,requestToken, commenteryData,isEditable,onOptionSectionChange,onOptionExpirySelect,onOptionStockSelect,onRemoveFile,onStockLossRecord }) => {
  const [optionSectionState, setOptionSectionState] = useState({
    optionReportType:'CALL',
    stockType: '',
    optionCMP: '',
    optionSL: '0',
    strikePrice:'',
    underlayingPrice: '',
    optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.',
    commentry:'',
    Expiry:'',
    volume:''
  });
  const options = stockSymbols.map((data) => ({
    ...data,
    value: data.name,
    label: data.name,
  }));
  const customStyles = {
    // Define your custom styles here
    menu: (provided) => ({
      ...provided,
      width: '256px',
      marginLeft:'185px'
    }),
    control: (provided, state) => ({
      ...provided,
      width: '256px', // Set the desired width for the entire component
      border: '1px solid #ccc',
      borderRadius: '4px',
      boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : null,
      '&:hover': {
        border: '1px solid #2684FF',
      },
    }),
    // Add more styles for other elements as needed
  };
  const [expiryData,setExpiryData]=useState([]);
  const [expiryshow,setexpiryshow]=useState(false);
  const [underlayingPriceerror,setunderlayingPriceError]=useState(false)
  const [optioncmperror,setOptionCmpError]=useState(false)
  const [slerror,setSlError]=useState(false)
  const [volumeError,setVolumeError]=useState(false)
  const [strikePriceerror,setstrikePriceError]=useState(false)
  const [volumeData,setVolumeData] = useState([])
  const [optionSectionErrorMsz, setOptionSectionErrorMsz] = useState('');
  const [optionSectionError, setOptionSectionError] = useState(false);
  const [loading,setLoading]=useState(false);
  const [togglesymbol, setToggleSymbol] = useState(true);
  let RemarkText = 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.'
  
  // to handle the change in the  input
  const handleInputChange = (event) => {
    setunderlayingPriceError(false);
    setOptionCmpError(false);
    setSlError(false);
    setstrikePriceError(false);
    const { name, value } = event.target;
     if (/^\d*\.?\d{0,2}$/.test(value)) {
    setOptionSectionState((prevState) => {
      let  newState 
      if(name === 'optionSL' && value == '0'){
        
        newState = {
          ...prevState,
          [name]: value,
          optionRemark:RemarkText
        };
      }
      else if(name === 'optionSL' && value != '0'){
        newState = {
          ...prevState,
          [name]: value,
          optionRemark:""
        };
      }
      else{
        newState = {
          ...prevState,
          [name]: value,
       
        };
      }
      
  
      // Log the updated state
      console.log("OptionSectionState", newState);
  
      // Notify the parent component about the change
      onOptionSectionChange(newState);
  
      return newState;
    });
  }else {
    if(name === 'optionCMP'){
      setOptionCmpError(true)
      setTimeout(() => {
        setOptionCmpError(false)
      }, 2000);
    }
    else if(name === 'underlayingPrice'){
      setunderlayingPriceError(true)
      setTimeout(() => {
        setunderlayingPriceError(false)
      }, 2000);
    }
    else if(name === 'strikePrice'){
      setstrikePriceError(true)
      setTimeout(() => {
        setstrikePriceError(false)
      }, 2000);
    }
    else if(name === 'optionSL'){
setSlError(true)
setTimeout(() => {
  setSlError(false)
}, 2000);
    }
    else if(name === 'volume'){
      setVolumeError(true)
      setTimeout(() => {
       setVolumeError(false)
      }, 2000);
    }
  }

  };
  

 
//  to handle the change in the radio button buy or sell
  const handleChange = (event) => {
  
    const { name, value } = event.target;
 
    setOptionSectionState((prevState) => {
      const newState = {
        ...prevState,
        [name]: value,
      };
  
      // Log the updated state
      console.log("OptionSectionState", newState);
  
      // Notify the parent component about the change
      onOptionSectionChange(newState);
  
      return newState;
    });
 

  };

  // to handle the change in the stock selection
  const handlechangestock = async(event)=>{
    // const { name, value } = event.target;
    const type = 'NFO-OPT';

    setOptionSectionState((prevState) => {
      const newState = {
        ...prevState,
        stockType: event.value,
        optionCMP:"",
        optionSL:'0',
        strikePrice:"",
        underlayingPrice: '',
        optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.',
        commentry:'',
        Expiry:'',
        volume:''
  
      };
      onRemoveFile();
     
      const selectedStockRecord = stockSymbols.find(item => item.name === event.value);
        
      onOptionStockSelect(selectedStockRecord);
      onOptionSectionChange(newState);
  
      return newState;
    });
   
   
 

    await fetch(`${BASE_URL}/getstockexpiry/${event.value}/${type}`, {
      method: 'GET'
  })
      .then(response => response.json())
      .then(res => {
          // Process the API response data
          console.log(res);

          if (res.success === true) {
              console.log("res.data",res.data);
              
              let expiryData= JSON.parse(res.data[0].dates);

              console.log("expiryData", expiryData);
          
              setExpiryData(expiryData)
              setexpiryshow(true)
          }
          else {  
            setOptionSectionErrorMsz(`Error: ${res.message}`);
            setOptionSectionError(true);
            setTimeout(() => {
              
              setOptionSectionError(false);
              setOptionSectionErrorMsz('');
            }, 2000);
          }
      })
      .catch(error => {
          // Handle errors
          setOptionSectionErrorMsz(`Error: ${error.message}`);
          setOptionSectionError(true);
          setTimeout(() => {
            
            setOptionSectionError(false);
            setOptionSectionErrorMsz('');
          }, 2000);
          console.error('Error fetching data:', error);
      });
  }

  // handle the change in the expiry selection
  const handlechangeExpiry= async(event)=>{
    const { name, value } = event.target;
  
    setOptionSectionState((prevState) => {
      const newState = {
        ...prevState,
        [name]: value,
      };
  
      // Log the updated state
      // console.log("OptionSectionState", newState);
  
      // Notify the parent component about the change
      // const selectedExpiryRecord = expiryData.find(item => item.expiry === value);
      // // console.log("selectedExpiryRecord",selectedExpiryRecord)
      // onOptionExpirySelect(selectedExpiryRecord);
      onOptionSectionChange(newState);
  
      return newState;
    });

    // onOptionSectionChange(optionSectionState);

  }

  // format the date to dd-mm-yyyy
  const  formatDate = (dateString) => {
    // console.log("dateString",dateString)
    const dateObject = new Date(dateString);
    const day = dateObject.getDate();
    const month = dateObject.getMonth() + 1; // Months are zero-based
    const year = dateObject.getFullYear();

    // Pad single-digit day and month with a leading zero
    const formattedDate = `${day < 10 ? '0' : ''}${day}-${month < 10 ? '0' : ''}${month}-${year}`;

    return formattedDate;
  }

  // handle the change in the commentary selection
const handleOptionChange = (event) => {
  const { name, value } = event.target;

  setOptionSectionState((prevState) => {
    const newState = {
      ...prevState,
      [name]: value,
    };
    onOptionSectionChange(newState);

    
    return newState;
  });
  

};


// handle the change in the volume selection
const handleVolumeChange = async(event)=>{
  const { name, value } = event.target;
  // console.log("event.target",event.target.name)
  // console.log("event.target",event.target.value)
  setOptionSectionState((prevState) => {
    const newState = {
      ...prevState,
      [name]: value,
    };

    
    onOptionSectionChange(newState);

    return newState;
  });
}

// to handle clear volume data
const clearVolumeData =()=>{
  setVolumeData([])
}

// to handle the change in the stock name using manual input
const handleStockChangeManual = async(event)=>{
  const{name,value} = event.target
  setOptionSectionState((prevState) => {
    const newState = {
      ...prevState,
      [name]: value,
      optionCMP: '',
      optionSL: '0',
      strikePrice:'',
      underlayingPrice: '',
      optionRemark: 'Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.',
      commentry:'',
      Expiry:'',
      volume:''
    };

    onRemoveFile();

    onOptionSectionChange(newState);
    return newState;
  });
}
const IOSSwitch = styled((props) => (
  <Switch
    focusVisibleClassName=".Mui-focusVisible"
    disableRipple
    {...props}
  />
))(({ theme }) => ({
  width: 30,
  height: 14,
  padding: 0,
  margin:'0 5px 0 -55px',
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor:
          theme.palette.mode === "dark" ? "#2ECA45" : "#23499E",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #23499E",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 10,
    height: 10,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));


// to handle the change in the toggle button to fill all fileds manually or auto
const handleToogleSymbolChange = (event) => {

  event.preventDefault();
  // console.log("event.target.checked", event.target.checked);
  setToggleSymbol(event.target.checked);
  setexpiryshow(false)

};


// to handle the change in the expiry date using manual input
const handleExpiryChange =(event)=>{
console.log("event",event.target.value)
const{name,value} = event.target
//  let date = formatDate(value)
 setOptionSectionState((prevState) => {
  const newState = {
    ...prevState,
    [name]: value,
  };

 
  onOptionSectionChange(newState);

  return newState;
});
}


  return (
    <div className="optionmain">
       {loading ?
            <div style={{   
                position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 2,
            }}>
              <Loading />
            </div> : null}
      <div id="btnoptionDiv" className="btnoptiondiv">
        <p>CALL</p>
        <input type="radio" value="CALL" defaultChecked name="optionReportType" onChange={handleChange} />

        <p>PUT</p>
        <input type="radio" value="PUT" name="optionReportType" onChange={handleChange} />
      </div>

      <div id="option_content" className="optioncontent">
        <div>
          <p>Stock Name:<span className='asterisk'>*</span></p>
        
          <IOSSwitch
                    sx={{ m: 1 }}
                    defaultChecked
                    checked={togglesymbol}
                    onChange={handleToogleSymbolChange}
                    inputProps={{ "aria-label": "controlled" }}
                  />
{togglesymbol ? (
          <ReactSelect
          id="OptionStocktype" 
          name="stockType"
          options={options}
          onChange={handlechangestock}
          styles={customStyles}
          disabled={!isEditable}
          />
):(
<input value={optionSectionState.stockType} type='text' id="stockType" name="stockType" required  onChange={handleStockChangeManual} disabled={!isEditable}/>
)}
        </div>

        { togglesymbol ?
         expiryshow ?
        <div style={{marginTop:'16px'}}>
          <p>Expiry:<span className='asterisk'>*</span></p>
          <select id="optionexpiry" value={optionSectionState.Expiry} name="Expiry" required onChange={handlechangeExpiry} disabled={!isEditable}>
            <option value="">Select Expiry</option>
            {expiryData.map((expiry) => (
              <option key={expiry} value={expiry.expiry}>
                {formatDate(expiry.expiry)}
              </option>
            ))}
          </select>
        </div>
        :null
        :<div style={{marginTop:'16px'}}>
        <p>Expiry:<span className='asterisk'>*</span></p>
        <input value={optionSectionState.Expiry} type="date" id="Expiry" name="Expiry"  onChange={handleExpiryChange} disabled={!isEditable}/>
      </div>
      }
        
        {optioncmperror?<span style={{color:'red',fontSize:'15px'}}>Numeric input with 2 decimal places (0-9).</span>:null}
       
        <div style={{marginTop:'16px'}}>
          <p>UnderLying Price:<span className='asterisk'>*</span></p>
         
          <input value={optionSectionState.optionCMP} type="number" id="optioncmp" name="optionCMP" required onChange={handleInputChange} disabled={!isEditable}/>
        </div>
      

{strikePriceerror?<span style={{color:'red',fontSize:'15px'}}>Numeric input with 2 decimal places (0-9).</span>:null}
  <div>
          <p>Strike Price:<span className='asterisk'>*</span></p>
        

      
           <input value={optionSectionState.strikePrice} type="number" id="strikePrice" name="strikePrice" required  onChange={handleInputChange} disabled={!isEditable}/>
       
        </div>

        
{underlayingPriceerror?<span style={{color:'red',fontSize:'15px'}}>Numeric input with 2 decimal places (0-9).</span>:null}
 <div>
          <p>Option CMP:<span className='asterisk'>*</span></p>
        
         
          <input value={optionSectionState.underlayingPrice} type="number" id="underlayingprice" name="underlayingPrice" required  onChange={handleInputChange} disabled={!isEditable} />
      
        </div>

        {slerror?<span style={{color:'red',fontSize:'15px'}}>Numeric input with 2 decimal places (0-9).</span>:null}
       <div>
        
          <p>SL :<span className='asterisk'>*</span></p>
        
          
       
          <input value={optionSectionState.optionSL} type="number" id="Optionsl" name="optionSL" required onChange={handleInputChange} disabled={!isEditable}/>
        </div>

        {volumeError?<span style={{color:'red',fontSize:'15px'}}>Numeric input with 2 decimal places (0-9).</span>:null}
    
        <div>
          <p>Volume:</p>
          {volumeData.length > 0 ? (
      <>
          <select style={{width:'52%'}} id="volume" name="volume" value={optionSectionState.volume} onChange={handleVolumeChange} disabled={!isEditable}>
            <option value="">Select Volume</option>
            {volumeData.map((data,index) => (
                      <option key={index} value={data.volume}>
                        {data.volume}
                      </option>
                    ))}
          </select>
          <span style={{cursor:'pointer'}} className="clear-icon" onClick={clearVolumeData}>&#10006;</span>
          </>
          ):(
          <input value={optionSectionState.volume} type="number" id="volume" name="volume" required onChange={handleInputChange} disabled={!isEditable}/>
          )}
          </div>

        <div>
          <p>Select commentary:<span className='asterisk'>*</span></p>
          <select id="selectcommentry" name="commentry" value={optionSectionState.commentry} onChange={handleOptionChange} disabled={!isEditable}>
            <option value="">Select commentary</option>
            {commenteryData.map((data) => (
                      <option key={data.CommentaryName} value={data.Description}>
                        {data.CommentaryName}
                      </option>
                    ))}
          </select>
          
        </div>


        <div>
          <p>Commentary Remarks:</p>
          <textarea style={{
  border: `2px solid ${optionSectionState.optionSL == '0' ? 'red' : 'rgba(0, 0, 0, 0.2)'}`,
  outline: 'none',
}} value={optionSectionState.optionRemark}  id="optionremark" name="optionRemark" required rows={4} onChange={handleChange} disabled={!isEditable}/>
        </div>
      </div>
          <Dialog
              open={optionSectionError}
              onClose={() => {
                setOptionSectionError(false);
              }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <div>
                    <span>
                      <i
                        className="pi pi-exclamation-circle"
                        style={{ color: "#FF6060" }}
                      />
                      <br />
                      {optionSectionErrorMsz}
                    </span>
                  </div>
                </DialogContentText>
              </DialogContent>
            </Dialog>
    </div>
  );
};

export default OptionSection;
